"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConferenceProviderParticipantText = void 0;
const ConferenceProviderParticipantText = (provider) => `This programme takes place on ${provider}, please make sure you have ${provider} downloaded and setup.`;
exports.ConferenceProviderParticipantText = ConferenceProviderParticipantText;
